import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

const fb = require('./../firebase/firebase')

Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit('SET_CURRENT_USER', user)
    store.dispatch('fetchUserProfile')

    fb.usersCollection.doc(user.uid).onSnapshot(doc => {
      store.commit('SET_USER_PROFILE', doc.data())
    })
  }
})

export const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    orgCardKitId: null,
    confirmationMsg: null
  },
  mutations: {
    SET_CURRENT_USER(state, val) {
      state.currentUser = val
    },
    SET_USER_PROFILE(state, val) {
      state.userProfile = val
    },
    SET_ORG_CARD_KIT_ID(state, val) {
      state.orgCardKitId = val
    },
    SET_CONFIRMATION_MSG(state, val) {
      state.confirmationMsg = val
    }
  },
  actions: {
    clearData({ commit }) {
      commit('SET_CURRENT_USER', null)
      commit('SET_USER_PROFILE', {})
    },
    fetchUserProfile({ commit, state }) {
      fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
        commit('SET_USER_PROFILE', res.data())
      }).catch(err => {
        console.log(err)
      })
    }
  },
  plugins: [createPersistedState()]
})
